// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__dWk56","img":"Gallery_img__sIviN"};